import md5Hex from 'md5-hex';
export class JobDetailsClass {
    constructor() {
        this.identifier = {
            coords: 'data-jobs-map-coords',
            mapSmall: 'data-jobs-map-small',
            mapLarge: 'data-jobs-map-large'
        };

        this.coords = document.querySelector('[' + this.identifier.coords + ']')
            .getAttribute(this.identifier.coords)
            .split(',');

        this.maps = {
            small: {},
            big: {}
        };

        this.location = {};

        this.init();
    }

    init() {
        if (this.coords[0] && this.coords[1]) {
            this.setLocation();
            this.setMaps();
            this.addLocationPin();
        }
    }

    setLocation() {
        this.location = new Microsoft.Maps.Location(this.coords[0], this.coords[1]);
    }

    setMaps() {
        this.maps.small = new Microsoft.Maps.Map('[' + this.identifier.mapSmall + ']', {
            center: this.location,
            disablePanning: true,
            disableZooming: true,
            enableClickableLogo: false,
            showDashboard: false,
        });

        this.maps.big = new Microsoft.Maps.Map('[' + this.identifier.mapLarge + ']', {
            center: this.location,
            enableClickableLogo: false,
        });
    }

    addLocationPin() {
        const publicPath = getExtensionPath('leuchtfeuer', 'con-site');
        let pinLayer = new Microsoft.Maps.Layer(),
            pin = new Microsoft.Maps.Pushpin(this.location, {
                cursor: 'default',
                draggable: false,
                enableClickedStyle: false,
                enableHoverStyle: false,
                icon: publicPath + 'Icons/Provider/map_pin.svg'
            });

        // Add pin to layer and layer to those maps
        pinLayer.add(pin);
        this.maps.small.layers.insert(pinLayer);
        this.maps.big.layers.insert(pinLayer);
    }
}

export function getExtensionPath(vendorName, extensionName) {
    const path = `/vendor/${vendorName}/${extensionName}/`;
    return `/_assets/${md5Hex(path)}/`;
}

document.addEventListener('newJobDetailsClass', function() {
    new JobDetailsClass();
});
